module.exports = {
	"Allocation": 674,
	"International Equity": 1094,
	"Sector Equity": 869,
	"U.S. Large Cap Equity": 1459,
	"U.S. Small/Mid Cap Equity": 1106
};


//////////////////
// WEBPACK FOOTER
// ./src/data/GefScoreNormalizersGroups.json
// module id = 954
// module chunks = 0